"use strict";
import Detection from "../widgets/detection.js"

App.Pages.Detections = class Detections extends PF.Page {

    static get options() {
        return {
            rights: {
                user: true
            },
            path: '/detections',
            nameRu: 'Детекции',
        };
    }

    static get template() {
        //language=HTML
        return `
			<div class="page navbar-fixed">
                
                <div class="page-content" pf="listContent">

                    <div class="page-header">
                        <h3>Детекции</h3>
                    </div>
                    
                    <div class="stretch-block">
                        <form class="filterForm" pf="form">
                            <div pf="elements"></div>
                            <div class="row resizable">
                                <div class="col-65">
                                    <div pf="preset"></div>
                                </div>
                                <div class="col-15">
                                    <input pf="dates"/>
                                </div>
                                <div class="col-20">
                                    <input pf="quality"/>
                                </div>
                            </div>
                        </form>
                        <div class="content card" style="margin:0;">
                            <div class="list" pf="list"></div>
                        </div>
                    </div>

                </div>
			</div>

		`;
    }

    init() {
        super.init();

        this.statFilters = new PF.Model({ represent: "user-data/stat-filters", saveOnModify: true, raw: { data: {} } });

        this.statFilters.onValue('options.loadStatus', 'loaded', () =>
        {
            this.form = new PF.Form({
                dom: { element: this.dom.form },
                model: this.statFilters,
                keyPrefix: 'data.',
                toastOnSave: false,
                fieldsConfig: {
                    elements: {
                        class: PF.Field.TreeMultiSelect,
                        label: 'Выберете камеры:',
                        includeRoot: false,
                        types: {
                            root: {
                                model: new PF.Model({ raw: { id: 'root', name: 'Все', server_vas: this.statFilters.options.dicts.server_vas } }),
                                childsKey: 'server_vas',
                            },
                            server_va: {
                                childsKey: 'elements',
                            },
                            element: {
                                childsKey: 'childs',
                            },
                            camera: {
                                selectable: true,
                                key: 'data.cameras',
                                modelsConfig: {
                                    deletePolicy: 'delete'
                                },
                            },
                        },
						simpleTitle: (count) =>
						{
							Util.sleep(2).then(() =>
							{
								if (count < 4 && count > 0)
								{
									let cameras = this.statFilters.data.cameras;
									let t = Util.spell(count, ['', 'Выбрана:', 'Выбраны:', 'Выбраны:']);
									for (let i = 0; i < cameras.size; i++)
									{
										if (i === 0)
										{
											t += ` "${cameras[i].name}"`;
										} else
										{
											t += `, "${cameras[i].name}"`;
										}
									}
									this.statFilters.options.form.fields.elements.simpleTitleText = t;
								}
							});
							return `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`;
						},
                    },
                    dateDiapason: {
                        class: PF.Field.DateDiapasonWithPreset,
                        presetConfig: {
                            dom: {
                                element: this.dom.preset
                            },
                            key: 'data.diapasonPreset',
                        },
                        datesConfig: {
                            dom: {
                                element: this.dom.dates
                            },
                            startKey: 'data.calendar.start',
                            finishKey: 'data.calendar.finish',
                        },
                    },
					quality: {
						class: PF.Field.Float,
						label: 'Мин качество(%)',
						minValue: 0,
						maxValue: 100,
					}
                }
            });

            this.statFilters.on('save-success', () =>
            {
                this.initList();
                this.listPersons.calc("title", "models.count", (count) => isFinite(count) ? `Найдено ${count} ${Util.spell(count, ['', 'детекция', 'детекции', 'детекций'])}` : ``);
            }, true);

        });

    }



    initList()
    {
        if (this.listPersons !== undefined)
        {
            this.listPersons.models.reload();
            return;
        }

        this.listPersons = new PF.List({
            dom: {
                element: this.dom.list,
                scrollTarget: this.dom.listContent,
            },
            // searchable: false,
            searchable: true,
            searchLabel: 'Поиск по ид детекции',
            modelsConfig: {
                represent: 'detection/ViewAll',
                limit: 10,
            },
            itemClass: Detection,
            searchConfig: ' @{id} ~ @{list.searchField} '
        });

    }
};